/* Marvellia - Offer Picker */
(function () {
  'use strict';

  function routesRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root;
    return '/';
  }

  function init(root) {
    if (!root || root.dataset.opReady === 'true') return;
    root.dataset.opReady = 'true';

    var goal = parseInt(root.dataset.goal, 10) || 3;
    var strings = {};
    try { strings = JSON.parse(root.querySelector('[data-op-strings]').textContent); } catch (e) { strings = {}; }

    var elFill = root.querySelector('[data-fill]');
    var elTrack = root.querySelector('[data-track]');
    var elPips = root.querySelectorAll('[data-pip]');
    var elMsg = root.querySelector('[data-msg]');
    var elSlots = root.querySelector('[data-slots]');
    var elSummary = root.querySelector('[data-summary]');
    var elSubmit = root.querySelector('[data-submit]');
    var elSubmitLabel = root.querySelector('[data-submit-label]');
    var elModal = root.querySelector('[data-modal]');
    var elSelect = root.querySelector('[data-select]');

    var chosen = [];

    function money(cents) {
      var fmt = strings.moneyFormat || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(cents / 100)));
    }

    function indexOfProduct(id) {
      for (var i = 0; i < chosen.length; i++) { if (chosen[i].productId === id) return i; }
      return -1;
    }

    function showPanel(blockId) {
      root.querySelectorAll('[data-tab]').forEach(function (t) {
        t.setAttribute('aria-selected', String(t.dataset.tab === blockId));
      });
      root.querySelectorAll('[data-panel]').forEach(function (p) {
        p.hidden = p.dataset.panel !== blockId;
      });
      if (elSelect && elSelect.value !== blockId) elSelect.value = blockId;
    }

    root.querySelectorAll('[data-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () { showPanel(tab.dataset.tab); });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
        var i = tabs.indexOf(tab);
        var n = e.key === 'ArrowRight' ? (i + 1) % tabs.length : (i - 1 + tabs.length) % tabs.length;
        tabs[n].focus(); showPanel(tabs[n].dataset.tab); e.preventDefault();
      });
    });

    if (elSelect) elSelect.addEventListener('change', function () { showPanel(elSelect.value); });

    /* card swatches */
    root.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-swatch]');
      if (!sw || !root.contains(sw)) return;
      var card = sw.closest('[data-card]');
      if (!card) return;
      e.preventDefault();
      card.querySelectorAll('[data-swatch]').forEach(function (o) {
        o.setAttribute('aria-pressed', String(o === sw));
      });
      var img = card.querySelector('[data-card-image]');
      if (img && sw.dataset.image) img.src = sw.dataset.image;
      var label = card.querySelector('[data-variant-label]');
      if (label) label.textContent = sw.dataset.value || '';
      var pick = card.querySelector('[data-pick]');
      if (pick) {
        pick.dataset.variantId = sw.dataset.variantId;
        pick.dataset.price = sw.dataset.price;
        pick.dataset.image = sw.dataset.thumb || sw.dataset.image;
      }
      var pid = parseInt(card.dataset.productId, 10);
      var at = indexOfProduct(pid);
      if (at > -1) {
        chosen[at].variantId = parseInt(sw.dataset.variantId, 10);
        chosen[at].price = parseInt(sw.dataset.price, 10);
        chosen[at].thumb = sw.dataset.thumb || sw.dataset.image;
        render();
      }
    });

    /* choose / unchoose */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pick]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      var card = btn.closest('[data-card]');
      var pid = parseInt(card.dataset.productId, 10);
      var at = indexOfProduct(pid);
      if (at > -1) {
        chosen.splice(at, 1);
      } else if (chosen.length < goal) {
        chosen.push({
          productId: pid,
          variantId: parseInt(btn.dataset.variantId, 10),
          title: btn.dataset.title,
          price: parseInt(btn.dataset.price, 10) || 0,
          thumb: btn.dataset.image
        });
      }
      render();
    });

    function removeAt(i) { chosen.splice(i, 1); render(); }

    function render() {
      if (elFill) elFill.style.width = Math.min(100, (chosen.length / goal) * 100) + '%';
      if (elTrack) elTrack.setAttribute('aria-valuenow', String(chosen.length));

      Array.prototype.forEach.call(elPips, function (pip, i) {
        pip.classList.toggle('is-on', i < chosen.length && chosen.length < goal);
        pip.classList.toggle('is-done', chosen.length >= goal && i < chosen.length);
      });

      var total = chosen.reduce(function (a, c) { return a + c.price; }, 0);
      var left = goal - chosen.length;

      if (elMsg) {
        if (left > 0) {
          elMsg.classList.remove('is-complete');
          elMsg.textContent = (strings.remaining || 'Choose [n] more').replace('[n]', left);
        } else {
          elMsg.classList.add('is-complete');
          elMsg.textContent = (strings.complete || 'Set complete').replace('[v]', money(total));
        }
      }

      if (elSlots) {
        elSlots.innerHTML = '';
        for (var i = 0; i < goal; i++) {
          var slot = document.createElement('div');
          slot.className = 'op-slot';
          if (chosen[i]) {
            slot.classList.add('is-filled');
            var thumb = document.createElement('span');
            thumb.className = 'op-slot__thumb';
            if (chosen[i].thumb) {
              var im = document.createElement('img');
              im.src = chosen[i].thumb; im.alt = ''; im.width = 48; im.height = 48; im.loading = 'lazy';
              thumb.appendChild(im);
            }
            var nm = document.createElement('span');
            nm.textContent = chosen[i].title;
            var x = document.createElement('button');
            x.type = 'button'; x.className = 'op-slot__remove';
            x.setAttribute('aria-label', 'Remove ' + chosen[i].title);
            x.textContent = '×';
            (function (idx) { x.addEventListener('click', function () { removeAt(idx); }); })(i);
            slot.appendChild(thumb); slot.appendChild(nm); slot.appendChild(x);
          } else {
            slot.innerHTML = '<span class="op-slot__thumb"></span>';
            slot.appendChild(document.createTextNode((strings.piece || 'Piece') + ' ' + (i + 1)));
          }
          elSlots.appendChild(slot);
        }
      }

      root.querySelectorAll('[data-card]').forEach(function (card) {
        var pid = parseInt(card.dataset.productId, 10);
        var isChosen = indexOfProduct(pid) > -1;
        var isFull = chosen.length >= goal && !isChosen;
        card.classList.toggle('is-picked', isChosen);
        card.classList.toggle('is-locked', isFull);
        var b = card.querySelector('[data-pick]');
        if (b) {
          b.disabled = isFull;
          b.setAttribute('aria-pressed', String(isChosen));
          var lab = b.querySelector('[data-pick-label]');
          if (lab) lab.textContent = isChosen ? (strings.chosen || 'Chosen') : (strings.choose || 'Choose');
        }
      });

      if (elSummary) {
        elSummary.style.color = '';
        elSummary.textContent = chosen.length + ' / ' + goal + (total ? '  ·  ' + money(total) + ' included free' : '');
      }
      if (elSubmit) elSubmit.disabled = chosen.length < goal;
    }

    /* quick view */
    var lastFocus = null;

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quickview]');
      if (!btn || !root.contains(btn)) return;
      if (elModal.contains(btn)) return;
      e.preventDefault();
      openQuickView(btn.dataset.quickview, btn);
    });

    function openQuickView(handle, trigger) {
      lastFocus = trigger || document.activeElement;
      fetch(routesRoot() + 'products/' + handle + '?section_id=offer-quick-view')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          var content = wrap.querySelector('[data-qv-content]') || wrap;
          elModal.innerHTML = '';
          elModal.appendChild(content);
          elModal.hidden = false;
          document.body.classList.add('op-modal-open');
          syncModalToCard();
          var c = elModal.querySelector('[data-qv-close]');
          if (c) c.focus();
        })
        .catch(function () { window.location.href = routesRoot() + 'products/' + handle; });
    }

    /* show the colour the card already has selected */
    function syncModalToCard() {
      var add = elModal.querySelector('[data-qv-add]');
      if (!add) return;
      var card = root.querySelector('[data-card][data-product-id="' + add.dataset.productId + '"]');
      if (!card) return;
      var active = card.querySelector('[data-swatch][aria-pressed="true"]');
      if (!active) return;
      var twin = elModal.querySelector('[data-swatch][data-variant-id="' + active.dataset.variantId + '"]');
      if (twin) applyModalSwatch(twin);
    }

    function applyModalSwatch(sw) {
      elModal.querySelectorAll('[data-swatch]').forEach(function (o) {
        o.setAttribute('aria-pressed', String(o === sw));
      });
      var firstRadio = elModal.querySelector('.op-qv__r');
      var firstPhoto = elModal.querySelector('.op-qv__photo');
      if (firstRadio) firstRadio.checked = true;
      if (firstPhoto && sw.dataset.image) firstPhoto.src = sw.dataset.image;
      var add = elModal.querySelector('[data-qv-add]');
      if (add) add.dataset.variantId = sw.dataset.variantId;
    }

    function closeQuickView() {
      elModal.hidden = true;
      elModal.innerHTML = '';
      document.body.classList.remove('op-modal-open');
      if (lastFocus) lastFocus.focus();
    }

    elModal.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-swatch]');
      if (sw && elModal.contains(sw)) {
        e.preventDefault();
        e.stopPropagation();
        applyModalSwatch(sw);
        var add = elModal.querySelector('[data-qv-add]');
        if (add) {
          var card = root.querySelector('[data-card][data-product-id="' + add.dataset.productId + '"]');
          if (card) {
            var twin = card.querySelector('[data-swatch][data-variant-id="' + sw.dataset.variantId + '"]');
            if (twin) twin.click();
          }
        }
        return;
      }

      if (e.target === elModal || e.target.closest('[data-qv-close]')) { closeQuickView(); return; }

      var addBtn = e.target.closest('[data-qv-add]');
      if (addBtn) {
        var c2 = root.querySelector('[data-card][data-product-id="' + addBtn.dataset.productId + '"]');
        if (c2) {
          var pick = c2.querySelector('[data-pick]');
          if (pick && !pick.disabled) pick.click();
        }
        closeQuickView();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !elModal.hidden) closeQuickView();
    });

    /* add to cart */
    function mainVariantId() {
      var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (f && f.value) return parseInt(f.value, 10);
      return parseInt(strings.mainVariant, 10) || null;
    }

    function fail(msg) {
      elSubmit.disabled = false;
      elSubmitLabel.textContent = strings.submit || 'Complete your set';
      if (elSummary) {
        elSummary.textContent = 'Could not add to bag: ' + msg;
        elSummary.style.color = '#9A3B32';
      }
      if (window.console) console.error('[offer-picker] ' + msg);
    }

    elSubmit.addEventListener('click', function () {
      if (chosen.length < goal) return;
      elSubmit.disabled = true;
      elSubmitLabel.textContent = strings.adding || 'Adding...';
      if (elSummary) elSummary.style.color = '';

      var mainId = mainVariantId();
      if (!mainId) { fail('could not read the product variant id'); return; }

      var items = [{ id: mainId, quantity: 1 }];
      chosen.forEach(function (c) {
        items.push({ id: c.variantId, quantity: 1, properties: { _gift: 'true', _offer: root.dataset.sectionId } });
      });

      var bad = false;
      items.forEach(function (it) { if (!it.id || isNaN(it.id)) bad = true; });
      if (bad) { fail('one of the chosen pieces has no variant id'); return; }

      fetch(routesRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (b) {
            if (!r.ok) throw new Error(b.description || b.message || ('HTTP ' + r.status));
            return b;
          });
        })
        .then(function () { return refreshCart(); })
        .then(function () {
          elSubmitLabel.textContent = strings.submit || 'Complete your set';
          elSubmit.disabled = false;
          goToCart();
        })
        .catch(function (err) { fail(err && err.message ? err.message : 'unknown error'); });
    });

    function refreshCart() {
      return fetch(routesRoot() + '?sections=cart-drawer,cart-icon-bubble,cart-notification')
        .then(function (r) { return r.json(); })
        .then(function (secs) {
          Object.keys(secs).forEach(function (k) {
            var t = document.getElementById('shopify-section-' + k) || document.querySelector('#' + k);
            if (!t || typeof secs[k] !== 'string') return;
            var p = new DOMParser().parseFromString(secs[k], 'text/html');
            var fresh = p.querySelector('#shopify-section-' + k) || p.querySelector('#' + k) || p.body.firstElementChild;
            if (fresh) t.innerHTML = fresh.innerHTML;
          });
        })
        .catch(function () {});
    }

    function goToCart() {
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function' && !d.classList.contains('is-empty')) {
        try { d.open(); return; } catch (e) {}
      }
      window.location.href = routesRoot() + 'cart';
    }

    render();
  }

  function boot() { document.querySelectorAll('.offer-picker').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.offer-picker');
    if (el) init(el);
  });
})();
